import Badge from "@ingka/badge";
import React from "react";
import "@ingka/badge/dist/style.css";
import "@ingka/text/dist/style.css";

interface FixaBadgeProps {
  label: React.ReactNode;
  size?: "small" | "medium";
  colour?:
    "grey" | "black" | "white" | "blue" | "green" | "red" | "orange" | "yellow";
  ssrIcon?: (prefix?: string) => React.SVGProps<SVGElement>[];
  iconOnly?: boolean;
  className?: string;
  prefix?: string;
  "data-testid"?: string;
}

export const FixaBadge = (props: FixaBadgeProps) => {
  return <Badge {...props} />;
};
